import { classNames } from "@components/library/utils/classNames";
import { BackgroundDiagonalRings } from "./BackgroundDiagonalRings";
import { PlatformEmailForm } from "./PlatformEmailForm";

export const CTASection = ({
  className,
}: React.PropsWithChildren<{ className?: string }>) => {
  return (
    <BackgroundDiagonalRings className={className}>
      <div
        className={classNames(
          "container-xl mx-auto flex flex-col gap-4 py-48 text-center md:gap-12 md:py-160 md:pl-64 "
        )}
      >
        <h4 className="text-16-24 text-gray-700 dark:text-white md:font-display md:text-24-32">
          Get started today
        </h4>
        <h4 className="mb-24 font-display text-24-28 font-bold tracking-wide text-black dark:text-white md:mb-40 md:text-[56px] md:font-normal md:leading-[56px]">
          Start building custom AI in minutes
        </h4>
        <div className="mx-auto flex">
          <PlatformEmailForm />
        </div>
      </div>
    </BackgroundDiagonalRings>
  );
};
